/* eslint-disable no-param-reassign */
import { Point } from '../../type/common.interface';

// 对节点进行布局
export function layoutNode({
    pointsList,
    offset,
    contentArea,
}: {
    pointsList: Point[][];
    offset: { x: number; y: number };
    contentArea: {
        minX: number;
        minY: number;
        maxX: number;
        maxY: number;
        width: number;
        height: number;
        offset: { x: number; y: number };
    };
}) {
    return pointsList.map(points =>
        points?.map((point) => {
            let { x, y } = point;

            x += offset.x;
            y += offset.y;

            contentArea.minX = Math.min(contentArea.minX, x);
            contentArea.minY = Math.min(contentArea.minY, y);
            contentArea.maxX = Math.max(contentArea.maxX, x);
            contentArea.maxY = Math.max(contentArea.maxY, y);

            return { x, y };
        }));
}
